module.exports = __webpack_public_path__ + "img/Sales_Manager.dc02fc9a.png";